import React, { Component } from 'react';
import { AgGridReact } from 'ag-grid-react';
import { Loader } from 'semantic-ui-react';

import { ACTION_STATUS } from '../../../../utils/ActionStatus';
import BaseUrlConfig from '../../../../net/BaseUrlConfig';
import UrlConfig from '../../../../net/UrlConfig';

class CptGrid extends Component {
  constructor(props) {
    super(props);
    this.state = {
      columnDefs: [
        {
          field: 'id',
          headerName: 'ID',
          cellClass: 'non-number',
          width: 90,
          headerCheckboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          checkboxSelection: true,
        },
        { field: 'eventDate', headerName: 'Event Date', cellClass: 'non-number', width: 130 },
        { field: 'eventOrganizer', headerName: 'Event Organizer', cellClass: 'non-number', width: 180 },
        { field: 'eventName', headerName: 'Event Name', cellClass: 'non-number', width: 220 },
        { field: 'cptCategory', headerName: 'CPT Category', cellClass: 'non-number', width: 170 },
        { field: 'cptHours', headerName: 'CPT Hours', cellClass: 'non-number', width: 110 },
        {
          field: 'attachmentOriginName',
          headerName: 'Attachment',
          cellClass: 'non-number',
          width: 180,
          tooltipField: 'attachmentOriginName',
          cellRenderer: this.attachmentCellRenderer,
        },
        { field: 'remarks', headerName: 'Note', cellClass: 'non-number', width: 240 },
        {
          field: 'complianceApproval',
          headerName: 'Approval Status',
          cellClass: 'non-number',
          width: 150,
          cellStyle: this.approvalStatusCellStyle,
        },
        { field: 'lastUpdatedBy', headerName: 'Last Updated By', cellClass: 'non-number', width: 150 },
        { field: 'lastUpdateTime', headerName: 'Last Update Time', cellClass: 'non-number', width: 180 },
      ],
      defaultColDef: {
        enableCellChangeFlash: true,
        minWidth: 50,
        sortable: true,
        filter: true,
        resizable: true,
      },
      rowSelection: 'multiple',
      context: { componentParent: this },
      statusBar: {
        statusPanels: [
          {
            statusPanel: 'agTotalAndFilteredRowCountComponent',
            align: 'left',
          },
          {
            statusPanel: 'agTotalRowCountComponent',
            align: 'center',
          },
          { statusPanel: 'agFilteredRowCountComponent' },
          { statusPanel: 'agSelectedRowCountComponent' },
        ],
      },
    };
  }

  approvalStatusCellStyle = params => {
    if (params.value === 'Approved') {
      return { color: '#00b050' };
    }
    if (params.value === 'Rejected') {
      return { color: '#ff0000' };
    }
    return null;
  };

  attachmentCellRenderer = params => {
    const data = params.data || {};
    if (!data.attachment) {
      return '';
    }

    const link = document.createElement('a');
    link.innerText = data.attachmentOriginName || data.attachment;
    link.target = '_blank';
    link.href = `${BaseUrlConfig.api.REST_URL}${BaseUrlConfig.api.API_VERSION}${UrlConfig.DOWNLOAD_CPT_ATTACHMENT}/${data.attachment}`;
    return link;
  };

  getRowNodeId = data => data.id;

  onSelectionChanged = event => {
    const rowNodeArray = event.api.getSelectedNodes();
    const selectedCptInfoArray = rowNodeArray.map(rowNode => rowNode.data);
    this.props.selectCptInfo(selectedCptInfoArray);
  };

  render() {
    const { loadCptInfoActionStatus, loadCptInfoResp } = this.props;
    const isLoading = loadCptInfoActionStatus === ACTION_STATUS.LOGINING;
    const rowData = loadCptInfoResp && Array.isArray(loadCptInfoResp.data)
      ? loadCptInfoResp.data
      : [];

    return (
      <div className="ag-theme-balham grid-wrapper">
        {isLoading ? (
          <Loader active content="Loading..." />
        ) : (
          <AgGridReact
            columnDefs={this.state.columnDefs}
            rowData={rowData}
            defaultColDef={this.state.defaultColDef}
            rowSelection={this.state.rowSelection}
            suppressRowClickSelection={true}
            suppressAggFuncInHeader={true}

            animateRows={true}
            deltaRowDataMode={false}
            sideBar={true}
            enableRangeSelection={true}
            getRowNodeId={this.getRowNodeId}
            context={this.state.context}
            statusBar={this.state.statusBar}
            onSelectionChanged={this.onSelectionChanged}
          />
        )}
      </div>
    );
  }
}

export default CptGrid;
